import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import { useCopy } from "@/contexts/LanguageContext";

const COPY = {
  en: { h: "Lenders", p: "Fictional demonstration lenders. Real onboarding requires KYC and a participation agreement.", code: "Code", verified: "Verified", yes: "Yes", no: "No",
    types: { public_sector_bank: "Public sector bank", private_sector_bank: "Private sector bank", private_bank: "Private bank", small_finance_bank: "Small finance bank", nbfc: "NBFC", cooperative_bank: "Co-operative bank", rrb: "Regional rural bank" } },
  hi: { h: "ऋणदाता", p: "काल्पनिक प्रदर्शन ऋणदाता। वास्तविक जुड़ाव के लिए KYC और भागीदारी अनुबंध आवश्यक है।", code: "कोड", verified: "सत्यापित", yes: "हाँ", no: "नहीं",
    types: { public_sector_bank: "सार्वजनिक क्षेत्र बैंक", private_sector_bank: "निजी क्षेत्र बैंक", private_bank: "निजी बैंक", small_finance_bank: "लघु वित्त बैंक", nbfc: "NBFC", cooperative_bank: "सहकारी बैंक", rrb: "क्षेत्रीय ग्रामीण बैंक" } },
};

export default function AdminLenders() {
  const [items, setItems] = useState([]);
  const c = useCopy(COPY);
  useEffect(() => { api.get("/admin/lenders").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="admin-lenders">
      <div><h1 className="text-3xl font-bold text-slate-900 brand-heading">{c.h}</h1><p className="text-slate-600 mt-1 text-sm">{c.p}</p></div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((l) => (
          <div key={l.id} className="p-6 rounded-lg border border-slate-200 bg-white card-hover" data-testid={`lender-${l.code}`}>
            <div className="font-semibold text-slate-900 brand-heading">{l.name}</div>
            <div className="text-xs text-slate-500 capitalize">{c.types[l.type] || l.type?.replace(/_/g, " ")}</div>
            <div className="mt-3 text-xs">{c.code}: <span className="font-mono">{l.code}</span></div>
            <div className="mt-1 text-xs">{c.verified}: <span className="font-semibold">{l.verified ? c.yes : c.no}</span></div>
          </div>
        ))}
      </div>
      <DisclaimerBanner compact />
    </div>
  );
}
